export const ProductsSearchAPILimit = 20

export const ProductConfigureAccordionId = {
  Variants: 'variants',
  Ingredients: 'ingredients',
  AddonGroup: (index: number) => `addon-group-${index}`,
}
